import React from 'react'
import ContentfulJsonLdBlocks from 'src/components/shared/ContentfulJsonLdBlocks'
import Layout from 'src/components/layouts'
import WhoWeHelpStates from 'src/components/pages/BrandPages/WhoWeHelpStates'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'

export async function getServerSideProps() {
  const jsonLdSchemas = await getContentfulJsonLd('who-we-help/states/')

  return {
    props: {
      jsonLdSchemas,
    },
  }
}

const WhoWeHelpStatesPage = ({ jsonLdSchemas }) => {
  return (
    <>
      <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
      <Layout isBrandPage isFullBleed>
        <WhoWeHelpStates />
      </Layout>
    </>
  )
}

export default WhoWeHelpStatesPage
